import axios from "axios";
import { EmailReceiptRequest } from "../../types/request/emailReceiptRequest.type";
import { getApiUrl, getClientApiUrl } from "../kioskApp.service";
import { getLocalStorageAccessToken } from "../localStorage.service";
import { handleResponse } from "./apiHelper";
import { setSignInError, setAccessToken } from "../../store/auth/auth.reducer";
import store from "../../store/store";

// Helper function to check if we're in development mode
const isDevelopment = () => {
    const nodeEnv = process.env.NODE_ENV;
    const ptsUrl = process.env.REACT_APP_PTS_URL;
    const isDev = nodeEnv === 'development' || ptsUrl?.includes('localhost');
    
    console.log("🔍 Development check:", {
        NODE_ENV: nodeEnv,
        REACT_APP_PTS_URL: ptsUrl,
        isDevelopment: isDev
    });
    
    return isDev;
};

// Helper function to check if we should skip print requests in development
const shouldSkipPrintInDevelopment = () => {
    // Allow override via environment variable
    if (process.env.REACT_APP_ENABLE_PRINT_IN_DEV === 'true') {
        console.log("🔍 Print enabled in dev via REACT_APP_ENABLE_PRINT_IN_DEV=true");
        return false;
    }
    
    const shouldSkip = isDevelopment();
    console.log("🔍 Should skip print in development:", shouldSkip);
    return shouldSkip;
};

export const prepareReceipt = (receiptHtml: string) => {
    return axios.post(getApiUrl() + "/v1/kiosk/print/prepareReceipt", {
        Base64Content: receiptHtml
    }, {
        headers: {
            "Authorization": "Bearer " + getLocalStorageAccessToken()
        }
    }).catch((error) => {
            
        var errorMessage = "Unable to login to Kiosk. Please contact Xplor Recreation support for assistance";
        store.dispatch(setSignInError(errorMessage));
        store.dispatch(setAccessToken(null));
    }).then((response: any) => {
        const responseData = handleResponse<any>(response.data);
        return responseData;
    });
}

export const sendEmail = (receiptRequest: EmailReceiptRequest) => {
    return axios.post(getApiUrl() + "/v1/kiosk/attendUser/emailreceipt", receiptRequest, {
        headers: {
            "Authorization": "Bearer " + getLocalStorageAccessToken()
        }
    }).catch((error) => {
            
        var errorMessage = "Unable to login to Kiosk. Please contact Xplor Recreation support for assistance";
        store.dispatch(setSignInError(errorMessage));
        store.dispatch(setAccessToken(null));
    });
}

export const printReceipt = (data: any) => {
    console.log("🖨️ printReceipt called");
    
    // In development mode, skip the actual print request to avoid connection errors
    if (shouldSkipPrintInDevelopment()) {
        console.log("🖨️ Print service skipped in development mode (expected behavior)");
        console.log("💡 To enable print testing, set REACT_APP_ENABLE_PRINT_IN_DEV=true in your .env file");
        return Promise.resolve({ 
            data: { 
                success: false, 
                message: "Print service unavailable in development mode" 
            } 
        });
    }
    
    console.log("🖨️ Making actual print request to:", getClientApiUrl() + "PrintJobs/DispatchPrintJob");
    
    // Only make the actual request in production
    return axios.post(getClientApiUrl() + "PrintJobs/DispatchPrintJob", data)
        .catch((error) => {
            // Handle different types of errors
            if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
                console.error("Print service error:", error);
                console.error("Print service is not available in production.");
                return Promise.resolve({ 
                    data: { 
                        success: false, 
                        message: "Print service unavailable" 
                    } 
                });
            }
            
            // For other errors, log them regardless of environment
            console.error("Print service error:", error);
            return Promise.reject(error);
        });
}